import React from 'react'

export const Lupa = () => {
  return (
    <span className="material-symbols-outlined">
        search
    </span>
  )
}
